module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "animated-number"
  }, [_vm._v(_vm._s(_vm.displayNumber))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e26e727"}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/animated-number/AnimatedNumber.vue
// module id = 303
// module chunks = 1